import React, { useState, useEffect } from 'react';
import api from '../api';

const Tax = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/tax/')
      .then(res => setData(res.data))
      .catch(() => setError('Failed to load tax data'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const postAccrual = async () => {
    setBusy(true);
    setError('');
    setMessage('');
    try {
      const res = await api.post('/tax/post_accrual/');
      setMessage(`Posted tax accrual JE #${res.data.journal_entry_id} for ${Number(res.data.amount).toLocaleString()}`);
      load();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to post tax accrual');
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!data) return <div className="error">{error || 'No data'}</div>;

  const formatLabel = (key) =>
    key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

  return (
    <div>
      <div className="flex-between">
        <h2>Tax</h2>
        <button className="btn btn-primary" onClick={postAccrual} disabled={busy}>
          {busy ? 'Posting...' : 'Post Tax Accrual JE'}
        </button>
      </div>
      {error && <div className="error">{error}</div>}
      {message && <div style={{ color: '#1a7a42', marginBottom: 12 }}>{message}</div>}
      <div className="stats-grid">
        {Object.entries(data).map(([key, value]) => (
          <div className="stat-card" key={key}>
            <h3>{formatLabel(key)}</h3>
            <p>{Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 })}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tax;
